.root {
  z-index: 100000;

  :global {
    .ant-modal-body {
      text-align: center;
    }
  }
}
